module.exports = __webpack_public_path__ + "img/title.c4d93cf1.png";